type AppChipProps<T> = {
  value: T | null;
  getColor: (value: T) => string;
  title?: string;
  displayValue?: string | null;
  className?: string;
  style?: React.CSSProperties;
};

export const AppChip = <T,>({ value, getColor, title, displayValue, className, style }: AppChipProps<T>) => {
  const colorClass = value !== null && value !== undefined ? getColor(value) : 'default';

  return (
    <span style={style} className={`custom_chip px-3 custom_chip--rounded custom_chip--${colorClass}${className ? ` ${className}` : ''}`}>
      {value !== null && value !== undefined ? (
        <span className="overflow-ellipsis text-capitalize" title={title ?? displayValue ?? String(value)}>
          {displayValue ?? String(value)}
        </span>
      ) : (
        '-'
      )}
    </span>
  );
};

export default AppChip;
